import { NgModule } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'

import { CustomMaterialInputControlComponent } from './custom-field.component'

@NgModule({
  imports: [
    MatFormFieldModule,
  ],
  declarations: [CustomMaterialInputControlComponent],
})
export class CustomFieldModule {}
